module.exports = __webpack_public_path__ + "media/images/lb/411-d8abc7d2daadf0ff9e925194b2bf53ce.svg";